import { useContext } from "react";

import { TransactionContext, TransactionContextType } from "../contexts/Transaction/TransactionContext";

export const useTransaction = (): TransactionContextType => {
  const context = useContext(TransactionContext);
  if (!context) {
    throw new Error("useTransaction must be used within a TransactionProvider");
  }
  return context;
};
